import { render, staticRenderFns } from "./BiddingStats.vue?vue&type=template&id=7a381aea&scoped=true&"
import script from "./BiddingStats.vue?vue&type=script&lang=js&"
export * from "./BiddingStats.vue?vue&type=script&lang=js&"
import style0 from "./BiddingStats.vue?vue&type=style&index=0&id=7a381aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a381aea",
  null
  
)

export default component.exports